import { SERVICES_RESP as servicesResp } from '../../configurations';
import { APP_SETTING_ACTION as appTypes,APP_THEME_SUPPORTS } from '../../constants/app';
import { PARAMS as requestParams } from '../../constants/params';
import { USER_ACTION } from '../../constants/user';
import { getDeviceInfo, saveSafeStorage, createCookie } from '../../helpers/global';
import {
  winVestLogin as winVestLoginServices,
  winVestRegister as winVestRegisterServices,
  winVestUpdateCustomer as winVestUpdateCustomerServices,
  winVestViewCustomer as winVestViewCustomerServices,
  winVestLogout as winVestLogoutServices
} from '../../services/win-vest-services';
import { STORAGE_KEY as storageKey } from '../../constants/storage.key';
import { userActions } from '../user';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import { Converter } from '@/helpers/functions';
import { switchStockSetting, switchTheme } from '../app'
import { THEME_COLOR_KEYS } from '@/constants/preference';


export const winVestLoginAction = (p, callback) => {
  // const defaultStockSetting = 'rise-green,fall-red'
  return (dispatch, getState) => {
    let params = {
      ...p,
      [requestParams.DEVICE]: getDeviceInfo().device,
      [requestParams.DEVICE_ID]: appConfigConstants.winvestorDeviceID,
      [requestParams.LANGUAGE]: Converter.mappingWinVestLanguage(getState().app.language.lang),
      [requestParams.CLIENT_THEME]: getState().app.theme
    }
    winVestLoginServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        // if(returnedServices.result.errorCode === servicesResp.SUCCESS_CODE) {
        saveSafeStorage(storageKey.WIN_VEST_CSRF_TOKEN, returnedServices.result.token);
        saveSafeStorage(storageKey.WIN_VEST_SESSION, returnedServices.result.sessid);
        saveSafeStorage(storageKey.WIN_VEST_SESSION_NAME, returnedServices.result.session_name);
        // cookies.set(`${returnedServices.result.session_name}`, `${returnedServices.result.sessid}`);
        createCookie(returnedServices.result.session_name, returnedServices.result.sessid)
        // saveSafeStorage(storageKey.WIN_VEST_UUID, returnedServices.result.id);
        callback(returnedServices.result);
        if (iTradeEnv?.actions?.trading?.getCashAccount){
          dispatch(userActions.getInstrumentWatchlistAction({ uuid : returnedServices.result.id}))
        }
        // dispatch(userActions.getPreferencesAction({ uuid: returnedServices.result.id }, res => {
        // }))
        // if(returnedServices?.result?.user_preference?.und){
          dispatch(switchStockSetting(returnedServices.result.user_preference.und))

          dispatch(switchTheme(returnedServices?.result?.user_preference?.und?.[THEME_COLOR_KEYS.SYSTEM] === APP_THEME_SUPPORTS[0]? APP_THEME_SUPPORTS[1] : APP_THEME_SUPPORTS[0]))

        // }
   
        
       
        
        dispatch({ type: USER_ACTION.SET_PREFERENCE, preference: returnedServices.result.user_preference })
        // }
      } else {
        // const toast = {
        //     type: 'error',
        //     autoClose: true,
        //     errorCode: returnedServices.status,
        //     isOpen: true
        // }
        // dispatch({
        //     type: appTypes.SHOW_TOAST,
        //     toast: toast
        // })
      }
    })
  }
}

export const winVestLogoutAction = () => {
  return dispatch => {
    winVestLogoutServices({}, returnedServices => {
      dispatch({ type: USER_ACTION.SET_PREFERENCE, preference: {} })
      if (returnedServices.status !== servicesResp.STATUS_OK) {
        // const toast = {
        //     type: 'error',
        //     autoClose: true,
        //     errorCode: returnedServices.status,
        //     isOpen: true
        // }
        // dispatch({
        //     type: appTypes.SHOW_TOAST,
        //     toast: toast
        // })
      }
    })
  }
}

export const winVestRegisterAction = (p, callback) => {
  let params = {
    ...p,
    [requestParams.DEVICE]: getDeviceInfo().device,
    [requestParams.DEVICE_ID]: appConfigConstants.winvestorDeviceID,
  }
  return dispatch => {
    winVestRegisterServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        // TO DO
      } else {
        // const toast = {
        //     type: 'error',
        //     autoClose: true,
        //     errorCode: returnedServices.status,
        //     isOpen: true
        // }
        // dispatch({
        //     type: appTypes.SHOW_TOAST,
        //     toast: toast
        // })
      }
    })
  }
}

export const winVestViewCustomerAction = (p, callback) => {
  let params = {
    ...p
  }
  return dispatch => {
    winVestViewCustomerServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        // const toast = {
        //     type: 'error',
        //     autoClose: true,
        //     errorCode: returnedServices.status,
        //     isOpen: true
        // }
        // dispatch({
        //     type: appTypes.SHOW_TOAST,
        //     toast: toast
        // })
      }
    })
  }
}

export const winVestUpdateCustomerAction = (p, callback) => {
  let params = {
    ...p
  }
  return dispatch => {
    winVestUpdateCustomerServices(params, returnedServices => {
      if (returnedServices.status === servicesResp.STATUS_OK) {
        callback(returnedServices.result)
      } else {
        // const toast = {
        //     type: 'error',
        //     autoClose: true,
        //     errorCode: returnedServices.status,
        //     isOpen: true
        // }
        // dispatch({
        //     type: appTypes.SHOW_TOAST,
        //     toast: toast
        // })
      }
    })
  }
}